import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import Checkbox from "expo-checkbox";
import { updateDataImage } from "../../../../services/Profile/profileService";
import AsyncStorage from "@react-native-async-storage/async-storage";

export default function OptionsFilter({
  options,
  filters,
  setFilters,
  name,
  multiselect,
  advanced,
}: {
  options: {
    label: string;
    active: boolean;
  }[];
  filters: any;
  setFilters: any;
  name: string;
  multiselect?: boolean;
  advanced?: boolean;
}) {
  const [optionState, setOptionState] = useState(options);

  useEffect(() => {
    // Update the checkbox state based on the initial filters
    const updatedOptions = optionState.map((option) => ({
      ...option,
      active:
        (advanced
          ? filters.advanceFilters[name]
          : filters.basicFilters[name]
        )?.includes(option.label) || option.active,
    }));
    setOptionState(updatedOptions);
  }, [filters]);

  const handleCheckBoxToggle = (index: any) => {
    const updatedOptions = optionState.map((option, i) => {
      if (!multiselect && i !== index) {
        return { ...option, active: false }; // For single-select, deactivate other options
      }
      if (i === index) {
        return { ...option, active: !option.active };
      }
      return option;
    });

    setOptionState(updatedOptions);

    const selectedOptions = updatedOptions
      .filter((option) => option.active)
      .map((option) => option.label);

    if (advanced) {
      setFilters((prevFilters: any) => {
        const updatedFilters = {
          ...prevFilters,
          advanceFilters: {
            ...prevFilters.advanceFilters,
            [name]: selectedOptions,
          },
        };

        // Save the updated state to AsyncStorage
        AsyncStorage.setItem("filters", JSON.stringify(updatedFilters));

        return updatedFilters;
      });
    } else {
      setFilters((prevFilters: any) => {
        const updatedFilters = {
          ...prevFilters,
          basicFilters: {
            ...prevFilters.basicFilters,
            [name]: selectedOptions,
          },
        };

        // Save the updated state to AsyncStorage
        AsyncStorage.setItem("filters", JSON.stringify(updatedFilters));

        return updatedFilters;
      });
    }
    // const update = async () => {
    //   const res = await updateDataImage({
    //     preferences: updateFilters,
    //   });
    //   if (res) {
    //     console.log("update success", res?.data?.data.preferences);
    //   }
    // };

    // if (name.trim() === "gender") {
    //   console.log("calling update");
    //   // update();
    // }
  };

  return (
    <ScrollView showsVerticalScrollIndicator={false} style={styles.Container}>
      {optionState?.map((option, index) => (
        <View key={index} style={styles.Options}>
          <Text>{option.label}</Text>
          <View style={styles.CheckboxContainer}>
            <Checkbox
              style={styles.checkbox}
              value={option.active}
              onValueChange={() => handleCheckBoxToggle(index)}
              color={"#C0A46F"}
            />
          </View>
        </View>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  Container: {
    width: "100%",
  },
  checkbox: {
    borderWidth: 0,
    padding: 2,
  },
  Options: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomColor: "#D9D9D9",
    borderBottomWidth: 0.5,
  },
  CheckboxContainer: {
    backgroundColor: "#F0EEED",
  },
});
